export class ChatMessageEndEvent {}
